import { useMutation } from '@apollo/client'
import { useSelector } from 'react-redux'

import {
  GetOrganizationDocument,
  UpsertBillingContactsDocument,
  UpsertBillingContactsMutationVariables,
} from '__generated__/atlas-types'

import { logMutationError } from 'utils/sdks/datadog'
import { toGlobalId } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'
import { getAccountId } from 'store/currentUser/selectors'

import { CONSOLE_LOG_KEY } from './billingContactModal.constants'
import useStore from './billingContactModal.store'

export const useUpsertBillingContacts = () => {
  const accountId = useSelector(getAccountId)
  const billingContacts = useStore((state) => state.billingContacts)
  const [mutate] = useMutation(UpsertBillingContactsDocument, {
    client: atlasClient,
    refetchQueries: [
      {
        query: GetOrganizationDocument,
        variables: { accountID: toGlobalId('Account', accountId) || '' },
      },
    ],
  })

  const upsertBillingContacts = async (
    organizationId: string,
  ): Promise<{ error: boolean }> => {
    const variables: UpsertBillingContactsMutationVariables = {
      organizationId,
      contacts: billingContacts.map((contact) => ({
        name: contact.name,
        email: contact.email,
      })),
    }

    try {
      const response = await mutate({ variables })

      if (response.errors && response.errors.length) {
        throw response.errors[0]
      }

      return { error: false }
    } catch (error) {
      logMutationError(
        'UpsertBillingContactsMutation',
        variables,
        `${CONSOLE_LOG_KEY}[Mutation] Error: ${(error as Error).message}`,
      )

      return { error: true }
    }
  }

  return { upsertBillingContacts }
}
